import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentComparisonApiService } from 'src/services/contentComparisonApi'

// The account's saved comparisons. No polling: a comparison is a definition,
// complete the moment it is created, so there is no run to watch.
export const useGetContentComparisonsQuery = () =>
  useQuery({
    queryFn: () => ContentComparisonApiService.getList(),
    queryKey: [QueryKey.GET_CONTENT_COMPARISONS],
  })
